// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-card {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.video-card .MuiCardMedia-root {
  transition: transform 0.3s ease;
}

.video-card:hover .MuiCardMedia-root {
  transform: scale(1.05);
}

.play-overlay {
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  padding: 24px;
}

@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoCard/VideoCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,SAAS;EACX;AACF","sourcesContent":[".video-card {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.video-card .MuiCardMedia-root {\n  transition: transform 0.3s ease;\n}\n\n.video-card:hover .MuiCardMedia-root {\n  transform: scale(1.05);\n}\n\n.play-overlay {\n  backdrop-filter: blur(2px);\n}\n\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 24px;\n  padding: 24px;\n}\n\n@media (max-width: 768px) {\n  .video-grid {\n    grid-template-columns: 1fr;\n    padding: 16px;\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
